import {
  DEFAULT_BRAND_COLORS,
  hexToHslChannels,
  isValidHex,
  readableForeground,
  type BrandColors,
} from '@/lib/branding';

interface InlineBrandStyleProps {
  colors?: Partial<BrandColors>;
}

export function InlineBrandStyle({ colors }: InlineBrandStyleProps) {
  const merged: BrandColors = {
    primary: colors?.primary || DEFAULT_BRAND_COLORS.primary,
    accent: colors?.accent || DEFAULT_BRAND_COLORS.accent,
    navy: colors?.navy || DEFAULT_BRAND_COLORS.navy,
  };

  // Validate the primary before deriving the real theme vars; an invalid stored
  // hex falls back to the default so the HSL conversion never produces garbage.
  const primaryHex =
    colors?.primary && isValidHex(colors.primary)
      ? colors.primary
      : DEFAULT_BRAND_COLORS.primary;

  // The legacy `--brand-*` vars stay for back-compat; `--primary` /
  // `--primary-foreground` are what the shadcn/Tailwind theme actually reads.
  // This <style> renders in the React body tree (after the <head> stylesheets),
  // so its :root wins by source order at equal specificity — no !important.
  const css = `:root {\n  --brand-primary: ${merged.primary};\n  --brand-accent: ${merged.accent};\n  --brand-navy: ${merged.navy};\n  --primary: ${hexToHslChannels(primaryHex)};\n  --primary-foreground: ${readableForeground(primaryHex)};\n}`;

  return <style data-testid="inline-brand-style">{css}</style>;
}
